import React from "react";
import { useRouteError } from "react-router-dom";
import ErrorMessage from "../ErrorMessage";

export default function ErrorPage() {
  let error = useRouteError();
  console.error(error);
  return <ErrorMessage error={error} />;
}
